import Footer from "@app/components/Footer";
import Header from "@app/components/Header";
import ScrollToTop from "@components/ScrollToTop/ScrollToTop";
import { useTheme } from "@src/app/hooks/useTheme";

import { useDfpPreview } from "../_ads/_hooks/useDfpPreview";
import GoogleAd, { GoogleAdTypeEnum } from "../_ads/GoogleAd/GoogleAd";

type CommonRenderProps = {
  children: React.ReactNode;
};

export default function CommonRender({ children }: CommonRenderProps) {
  const theme = useTheme();

  useDfpPreview();

  return (
    <div
      className={
        "bg-background-default dark:bg-background-primary-on-dark min-h-screen"
      }
    >
      {/* LB1 across all site */}
      <GoogleAd type={GoogleAdTypeEnum.LB1} className="py-2" />

      <Header theme={theme} />

      {children}

      <ScrollToTop />

      <Footer theme={theme} />
    </div>
  );
}
